export const ACCOUNTS_PARTNER_ID = import.meta.env.VITE_ACCOUNTS_PARTNER_ID;
export const ACCOUNTS_ENV = import.meta.env.VITE_ACCOUNTS_ENV;
export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;
export const MYEDUZZ_FRONT_URL = import.meta.env.VITE_MYEDUZZ_FRONT_URL;
export const MYEDUZZ_FRONT_2_URL = import.meta.env.VITE_MYEDUZZ_FRONT_2_URL;
export const BLINKET_FRONT_URL = import.meta.env.VITE_BLINKET_FRONT_URL;
export const GOOGLE_ANALYTICS_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
export const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const ENV = import.meta.env.VITE_ENV;

export const COMMIT_ID = import.meta.env.VITE_COMMIT_ID || '';
export const VERSION = import.meta.env.VITE_VERSION || '';
export const BRANCH = import.meta.env.VITE_BRANCH || '';
export const BUILD_ID = import.meta.env.VITE_BUILD_ID || '';

export const MAX_UPLOADS = 20;

export const DEFAULT_MAXIMUM_LATE_PAYMENTS = 5;
